export default __webpack_public_path__ + "static/media/case.6c7706e7.jpg";